import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class ProvinciaReferendum2025 extends Component {
  render() {
    let { regione, provincia } = this.props.params;
    let repoDettaglio = "/elezioni/withub/electionday-2025/referendum/" + regione + "/" + provincia + "/" + provincia + ".html";
    let repoFascione = "/elezioni/withub/electionday-2025/referendum/fascione-elezioni.html";
    return (
    <div className="App">
        <EWH id="ewh-fascione" repo={repoFascione} />
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
    </div>
    )
  }
}

export default withParams(ProvinciaReferendum2025)
